import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { View } from "react-native-ui-lib";
import { FlatActionList } from "@towersystems/roam-common-native";
import { Page } from "@towersystems/roam-common-native";
import { ReceiptModalRootParmList } from "../../../../types";
import { useDownloadReceipt } from "../../../../utilities/receipt/use-download-receipt";
import { useSaleContextProvider } from "../../utils";
import { useTranslation } from "../../../../utilities/i18n";

export type ReceiptOptionsModalScreenProps = NativeStackScreenProps<
  ReceiptModalRootParmList,
  "ReceiptOptionsModalScreen"
>;

export const ReceiptOptionsModalScreen = ({
  navigation,
}: ReceiptOptionsModalScreenProps) => {
  const { t } = useTranslation("sales");


  const items = [
    {
      key: "print",
      title: t("action.print_receipt.label"),
      subTitle: t("action.print_receipt.description"),
      onPress: () => navigation.navigate("PrintReceiptModalScreen"),
    },
    {
      key: "email",
      title: t("action.email_receipt.label"),
      subTitle: t("action.email_receipt.description"),
      onPress: () => navigation.navigate("PickEmailReceiptTemplateModalScreen"),
    },
    {
      key: "donwload",
      title: t("action.download_receipt.label"),
      subTitle: t("action.download_receipt.description"),
      onPress: () => navigation.navigate("DownloadReceiptScreen"),
    },
  ];
  return (
    <Page>
      <View>
        <FlatActionList items={items} />
      </View>
    </Page>
  );
};
